import React from 'react';
import CachedAppImage from './CachedAppImage';

type CharacterEmptyStateProps = {
  message: string;
  variant?: 'default' | 'modal';
  className?: string;
};

const CharacterEmptyState: React.FC<CharacterEmptyStateProps> = ({
  message,
  variant = 'default',
  className,
}) => {
  const classes = [
    'cp-character-empty',
    variant === 'modal' ? 'cp-character-empty--modal' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status">
      <div className="cp-character-empty__figure">
        <p className="cp-character-empty__bubble">{message}</p>
        <CachedAppImage file="character_1.webp" className="cp-character-empty__character" />
      </div>
    </div>
  );
};

export default CharacterEmptyState;
